module.exports = __webpack_public_path__ + "static/media/colheitadeira2.94e9f1d7.svg";